import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderWidgetComponent } from './header-widget.component';

@Component({
  template: `
    <a
      class="gridheader {{ header.key }}"
      data-toggle="tooltip"
      [attr.title]="
        header?.tooltipText &&
        (header?.tooltipText[selectedGroup] || header?.tooltipText['default'])
      "
      enTooltip
      [attr.data-tooltip-placement]="isLast ? 'left' : header?.tooltipPos"
    >
      <i
        class="fa fa-info-circle"
        *ngIf="
          header?.tooltipText &&
          (header?.tooltipText[selectedGroup] || header?.tooltipText['default'])
        "
      ></i>
      <span class="label" [innerHTML]="header?.label"></span>
    </a>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./grid-header.component.scss']
})
export class GridHeaderWithTooltipComponent extends HeaderWidgetComponent {}
